"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Colorbar;
var _react = _interopRequireWildcard(require("react"));
var _enums = require("../enums");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FAHRENHEIT = _enums.temperatureUnits.FAHRENHEIT,
  CELSIUS = _enums.temperatureUnits.CELSIUS;
var celsiusToFahrenheit = function celsiusToFahrenheit(value) {
  return value * 9 / 5 + 32;
};
var roundTo = function roundTo() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (typeof number !== "number" || typeof decimalPlaces !== "number") {
    throw new Error("Invalid arguments: number and decimalPlaces must be numbers");
  }
  try {
    return +number.toFixed(decimalPlaces);
  } catch (error) {
    console.error("An error occurred:", error);
  }
};
function Colorbar(_ref) {
  var _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$linearGradient = _ref.linearGradient,
    linearGradient = _ref$linearGradient === void 0 ? "" : _ref$linearGradient,
    _ref$temperatureUnit = _ref.temperatureUnit,
    temperatureUnit = _ref$temperatureUnit === void 0 ? "C" : _ref$temperatureUnit,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 15 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 480 : _ref$height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "black" : _ref$color,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? "bold" : _ref$fontWeight;
  var getFixedTemp = (0, _react.useCallback)(function (value) {
    var _value;
    value = (_value = value) !== null && _value !== void 0 ? _value : 0;
    if (temperatureUnit === FAHRENHEIT) {
      value = celsiusToFahrenheit(value);
    }
    value = roundTo(value, 1);
    return value;
  }, [temperatureUnit]);
  var getFormattedTemperature = (0, _react.useCallback)(function (value) {
    var temperature = getFixedTemp(value);
    return "\u2014 ".concat(temperature, " \xB0").concat(temperatureUnit !== null && temperatureUnit !== void 0 ? temperatureUnit : CELSIUS);
  }, [getFixedTemp, temperatureUnit]);
  var sliderTickMarks = (0, _react.useMemo)(function () {
    var numTicks = 10;
    var step = (max - min) / (numTicks - 1);
    var marks = [];
    for (var i = 0; i < numTicks; i++) {
      var value = min + i * step;
      var label = getFormattedTemperature(value);
      marks.push({
        value: value,
        label: label
      });
    }
    return marks;
  }, [getFormattedTemperature, min, max]);
  var styles = {
    gutter: {
      width: 85
    },
    slider: {
      position: "relative",
      minHeight: height - 4,
      // 2 x 2px border
      maxHeight: height - 4,
      // 2 x 2px border
      minWidth: width,
      maxWidth: width,
      margin: "0 -2px",
      // Adjust the pixel value as needed
      backgroundImage: linearGradient,
      border: "2px solid ".concat(color),
      borderRadius: 0,
      opacity: 1
    },
    tickMarker: function tickMarker(value) {
      return {
        position: "absolute",
        width: 100,
        left: width + 10,
        bottom: "".concat((value - min) / (max - min) * 100, "%"),
        // reverse order
        transform: "translateY(50%)",
        color: color,
        fontSize: "12px",
        fontWeight: fontWeight
      };
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: styles.gutter,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: styles.slider,
        children: sliderTickMarks.map(function (_ref2, index) {
          var value = _ref2.value,
            label = _ref2.label;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: styles.tickMarker(value),
            children: label
          }, "tick-label-".concat(index, "-").concat(value));
        })
      })
    })
  });
}